import { RawInfo } from "@/lib/raw/fastlib"
import { mat3, vec2, vec3 } from "gl-matrix"

export interface GenericWhiteBalanceInfo {
	neutralToXY: [number, number]
	camToPCS: number[]
	PCSToCam: number[]
	whiteBalance: { tint: number; temperature: number }
	whiteBalanceMultipliers: [number, number, number]
}

export abstract class GenericWhiteBalance {
	protected info: RawInfo

	public abstract get neutralToXY(): vec2
	public abstract get camToPCS(): mat3
	public abstract get PCSToCam(): mat3
	public abstract get whiteBalance(): { tint: number; temperature: number }
	public abstract get whiteBalanceMultipliers(): vec3

	constructor(info: RawInfo) {
		this.info = info
	}

	public toInfo(): GenericWhiteBalanceInfo {
		const xy = this.neutralToXY
		const cam = this.camToPCS
		const pcs = this.PCSToCam
		const wb = this.whiteBalance
		const mult = this.whiteBalanceMultipliers

		return {
			neutralToXY: [xy[0], xy[1]],
			camToPCS: Array.from(cam),
			PCSToCam: Array.from(pcs),
			whiteBalance: { tint: wb.tint, temperature: wb.temperature },
			whiteBalanceMultipliers: [mult[0], mult[1], mult[2]],
		}
	}
}
